export const PHONE_NUMBER_REGEX =
  /^(\([2-9]\d{2}\)|[2-9]\d{2})[\s.-]?\d{3}[\s.-]?\d{4}$/;
